import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSolutionApi } from "../../services/solution/delete.solution.api";

export const useDeleteSolutionApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => deleteSolutionApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["solution"],
      });
    },
  });
};
